
import { api } from '../services/redux-beesConfig';
import AuthService from './AuthService';
import store from '../Store';
import { getActiveLanguage } from 'react-localize-redux';

class InvoicesService {
  static getInvoices(page) {
    const userID = AuthService.getUserID();
    return api.getInvoices({ locale: `${getActiveLanguage(store.getState().locale).code}`, id: userID, 'page[number]': page, 'page[size]': 25 })
      .then((res) => {
        if (res.body.token) {
          AuthService.setToken(res.body.token);
        }
        return res;
      })
      .catch((error) => {
        if (error.status === 401) {
          AuthService.logOut();
        }
        console.log(error);
      });
  }
  static getInvoice(values) {
    const userID = AuthService.getUserID();
    return api.getInvoice({ locale: `${getActiveLanguage(store.getState().locale).code}`, id: userID, invoiceID: values })
      .then(res => res)
      .catch((error) => {
        if (error.status === 401) {
          AuthService.logOut();
        }
        console.log(error);
      });
  }
}

export default InvoicesService;



// WEBPACK FOOTER //
// ./src/services/InvoicesService.js